import React from 'react';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core';

import styles from './style';
import Typography from '../atomic/Typography';
import BallIcon from '../../assets/icons/Ball';

const PublicSharingLabel = ({ classes, labelProps }) => (
  <div className={classes.container}>
    <BallIcon className={classes.ballIcon} />

    <Typography
      {...labelProps}
      className={clsx(classes.label, labelProps && labelProps.className)}
    >
      OFFENTLIG DELT
    </Typography>
  </div>
);

export default withStyles(styles)(PublicSharingLabel);
